const t_titles = {
  Misure: "Size",
  Modello: "Model",
  Versione: "Type",
  Colore: "Color",
};

const t_filters = {
  'Anelli': "Rings",
  'Bicchiere': "Glass",
  "Bicchieri da acqua": "Water glasses",
  "Bicchieri per cocktail bar e liquori": "Glasses for cocktail bars and spirits",
  "Bicchieri per liquori e distillati": "Glasses for liqueurs and spirits",
  "Bicchieri per vini e spumanti": "Glasses for wines and sparkling wines",
  "Bicchieri per vino": "Wine glasses",
  "Bottoni gioiello": "Jewel buttons",
  'Bracciali': "Bracelets",
  "Candele e portacandele": "Candles and candle holders",
  'Ciondoli': "Pendants",
  'Clessidre': "Hourglasses",
  'Collane': "Necklaces",
  "Decanter e caraffe": "Decanters and carafes",
  "Degustazione olio": "Oil tasting",
  "Estrattori, distillatori evaporatori": "Extractors, evaporator distillers",
  "Fiori in vetro": "Flowers in glass",
  "Lampade design - lighting": "Designer lamps - lighting",
  'Orecchini': "Earrings",
  "Papillon e accessori da uomo": "Bow ties and accessories for men",
  "Pentole e cottura cibi": "Pots and cooking foods",
  "Piatti e accessori per la tavola": "Dishes and table accessories",
  "Profumatori per ambiente": "Air fresheners for the environment",
  "Profumi ambiente - Odori": "Home fragrances - Smells",
  "Teiere, caffettiere e breakfast": "Teapots, coffee pots and breakfasts",
  "Vasi per fiori": "Flower pots",
  'Alta': "High",
  'Bassa': "Low",
  "Caffè americano": "American coffee",
  "Caffè espresso": "Espresso",
  'Caraffa': "Carafe",
  'Argento': "Silver",
  "Argento rosato": "Rosy silver",
  'Azzurro': "Sky blue",
  'Bianca': "White",
  'Bianco': "White",
  "Bianco opalino": "Opal white",
  'Blu': "Blue",
  "Blu cobalto": "Cobalt blue",
  'Fucsia': "Fuchsia",
  "Felpa grigia": "Gray sweatshirt",
  'Grigio': "Grey",
  'Giallo': "Yellow",
  'Lilla': "Lilac",
  'Marrone': "Brown",
  'Melanzana': "Eggplant",
  'Nero': "Black",
  'Rosa': "Rose",
  'Rosso': "Red",
  'Sabbiato': "Sandblasted",
  'Satinato': "Satin",
  "Terra di siena": "Sienna",
  'Trasparente': "Transparent",
  'Verde': "Green",
  "1 sfera": "1 sphere",
  "3 sfere": "3 spheres",
  "Argento dorato": "Gilt silver",
  "Argento rodiato": "Rhodium plated silver",
  "Argento rosa": "Rose silver",
  "Big sabbiato": "Big sandblasted",
  "Big trasparente": "Big transparent",
  "Caffè americano": "American coffee",
  'Espresso': "Expressed",
  "Catena argento rodiato 45": "Rhodium plated silver chain 45",
  "Catena argento rodiato 45 cm": "Rhodium plated silver chain 45 cm",
  "Catena argento rodiato 90 cm": "Rhodium plated silver chain 90 cm",
  "Catena rolò 45 cm": "Curb chain 45 cm",
  "Catena rolò 80 cm": "Rolò chain 80 cm",
  "Catenina argento diamantato 45 cm": "Diamond silver chain 45 cm",
  "Catenina argento diamantato 90 cm": "Diamond silver chain 90 cm",
  'Ciondolo': "Pendant",
  "Collana rolò 45 cm": "Rolò necklace 45 cm",
  "Collana rolò 80 cm": "Rolò necklace 80 cm",
  "Conical medium per affumicatura": "Conical medium for smoking",
  "Conical small per affumicatura": "Conical small for smoking",
  "Olimpia rombo blu": "Olympia blue rhombus",
  "Olimpia rombo nero": "Olympia black rhombus",
  "Olimpia rombo verde": "Olympia green rhombus",
  "Olimpia rotondo bianco": "Round white Olympia",
  "Olimpia rotondo blu": "Round blue Olympia",
  "Olimpia rotondo nero": "Round black Olympia",
  "Olimpia rotondo verde": "Round green Olympia",
  "Piccolo diam. 12mm vetro bianco": "small dia. 12mm white glass",
  "Piccolo diam. 12mm vetro blu": "small dia. 12mm blue glass",
  "Piccolo diam. 12mm vetro nero": "small dia. 12mm black glass",
  'Prolunga': "Extension cord",
  'Sfera': "Ball",
  "Sfera blu": "Blue sphere",
  "Sfera trasparente": "Transparent sphere",
  "Small sabbiato": "Small sandblasted",
  "Small trasparente": "Small transparent",
  "Vetro curvo - cachemire bianco": "Curved glass - white cashmere",
  "Vetro curvo - cachemire grigio": "Curved glass - gray cashmere",
  'Alto': "High",
  'Basso': "Bass",
  "Con base": "With base",
  'Inciso': "Engraved",
  'Infusiera': "Infuser",
  "Liscio sabbiato": "Sandblasted smooth",
  "Liscio trasparente": "Transparent smooth",
  "Piatto in gres": "Stoneware plate",
  "Senza base": "Without base",
  "Suk bicchiere": "Souk glass",
  "Vaso/brocca": "Vase/jug",
};

function translateItems() {
  if ($("html").attr("lang") == "it") {
    return;
  }

  $(".filters-group h6.title").each(function () {
    $(this).text(t_titles[$(this).text()]);
  });

  $(".multiple-filters").each(function (idx) {
    $(this)
      .find(".filter-name")
      .each(function () {
        $(this).text(t_filters[$(this).text()]);
      });
  });

  $("facet-remove span").each(function () {
    $(this).text(t_filters[$.trim($(this).text())]);
  });
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true,
    },
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

  return _setPrototypeOf(o, p);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true,
      },
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static async renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading");

    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static async renderSectionFromFetch(url, event) {
    await fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        translateItems();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML;
    //SPR.registerCallbacks();
    //SPR.initRatingHandler();
    //SPR.initDomEls();
    //SPR.loadProducts();
    //SPR.loadBadges();
    $(document).ready(function () {
      // add-to-cart ajax-spin-cart js
      $(".ajax-spin-cart").on("click", function () {
        $(this).addClass("loading add-item");
        setTimeout(function () {
          $(".ajax-spin-cart").removeClass("loading");
        }, 1000);
        setTimeout(function () {
          $(".ajax-spin-cart").removeClass("add-item");
        }, 2000);
      });

      // add to cart js via product show mini-cart style1
      $(".mini1 .single-product-wrap a.add-to-cart").on("click", function () {
        window.setTimeout(function () {
          $(".mini1 #cart.mini-cart").addClass("check");
          setTimeout(RemoveClass, 4000);
        }, 1000);
      });
      function RemoveClass() {
        $(".mini1 #cart.mini-cart").removeClass("check");
      }

      $(".mini1 .shopping-cart a.cart-count-lg").on("click", function () {
        if ($(".mini1 #cart").hasClass("active")) {
          $(".mini1 #cart").removeClass("active");
          $(this).removeClass("active");
        } else {
          $(".mini1 #cart").addClass("active");
          $(this).addClass("active");
        }
      });

      $(".mini1 .read-agree").on("click", function () {
        if ($(".mini1 .cust-checkbox").is(":checked")) {
          $(".mini1 .checkout").removeAttr("disabled");
        } else {
          $(".mini1 .checkout").attr("disabled", "disabled");
        }
      });
      var sickyStatus = null;
      // add to cart js via product show mini-cart style2
      $(".mini2 .shopping-cart a.cart-count").click(function () {
        $(".mini2 .mini-cart").addClass("show");
        $(".mini2.mm-fullscreen-bg").addClass("active");
        $(".mini2 body").addClass("hidden");
      });
      $(".mini2 .shopping-cart-close i").click(function () {
        $(".mini2 .mini-cart").removeClass("show");
        $(".mini2 .mm-fullscreen-bg").removeClass("active");
        $(".mini2 body").removeClass("hidden");
      });
      $(".mini2 .mm-fullscreen-bg").click(function () {
        $(".mini2 .mini-cart").removeClass("show");
        $(".mini2 .mm-fullscreen-bg").removeClass("active");
      });
      
      
      $(".mini2 .single-product-wrap a.add-to-cart").on("click", function () {
        window.setTimeout(function () {
          $(".mini2 #cart.mini-cart").addClass("show");
          $(".mini2 .mm-fullscreen-bg").addClass("active");
          $(".mini2 body").addClass("hidden");
          
          console.log("Sticky check");
          if($(".header-kaj").hasClass("sticky-down")) {
            console.log("Sticky hasClass");
            $(".header-kaj").removeClass("sticky-down");
            sickyStatus = "sticky-down";
          }
        }, 1000);
      });
      $(".mini2 .shopping-cart-close i").on("click", function () {
        if ($(".mini2 #cart.mini-cart").hasClass("show")) {
          $(".mini2 #cart.mini-cart").removeClass("show");
        }
        $(".mini2 .mm-fullscreen-bg").removeClass("active");
        $(".mini2 body").removeClass("hidden");
      });
      $(".mini2 .mm-fullscreen-bg").on("click", function () {
        $(".mini2 #cart.mini-cart").removeClass("show");
        $(".mini2 .mm-fullscreen-bg").removeClass("active");
      });

      $(".mini2 .read-agree").on("click", function () {
        if ($(".mini2 .cust-checkbox").is(":checked")) {
          $(".mini2 .checkout").removeAttr("disabled");
        } else {
          $(".mini2 .checkout").attr("disabled", "disabled");
        }
      });

      // add to cart js via product show mini-cart style3
      $(".mini3 .single-product-wrap a.add-to-cart").on("click", function () {
        window.setTimeout(function () {
          console.log("OK CART");
          $(".mini3 .shopping-cart #cartmodal").modal("toggle");
        }, 1000);
      });

      $(".mini3 .read-agree").on("click", function () {
        if ($(".mini3 .cust-checkbox").is(":checked")) {
          $(".mini3 .checkout").removeAttr("disabled");
        } else {
          $(".mini3 .checkout").attr("disabled", "disabled");
        }
      });

      // add to cart js via product show mini-cart style4
      $(".mini4 .single-product-wrap a.add-to-cart").on("click", function () {
        window.setTimeout(function () {
          $(".mini4 .shopping-cart #cart").slideToggle("slow", function () {
            setTimeout("$('.mini4 .shopping-cart #cart').slideToggle('slow');", 4000);
          });
        }, 1000);
      });

      $(".mini4 .read-agree").on("click", function () {
        if ($(".mini4 .cust-checkbox").is(":checked")) {
          $(".mini4 .checkout").removeAttr("disabled");
        } else {
          $(".mini4 .checkout").attr("disabled", "disabled");
        }
      });

      // wishlist js
      var $wishlistButton = $(".wishlist-btn");
      var $wishlistTile = $(".wishlist-tile-container");
      var $wishlitcounter = $(".wishlist-counter");
      var numProductTiles = $wishlistTile.length;
      var wishlist = localStorage.getItem("user_wishlist") || [];
      var wishlist_count_set = localStorage.getItem("user_wishlist_count");
      if (wishlist_count_set == null) {
        var wishlist_count = "0";
        $wishlitcounter.html(wishlist_count);
      } else {
        $wishlitcounter.html(wishlist_count_set);
      }
      if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem("user_wishlist"));
      }

      /*
       * Update button to show current state (gold for active)
       */
      var animateWishlist = function (self) {
        $(self).toggleClass("is-active");
      };


      /*
       * Add/Remove selected item to the user's wishlist array in localStorage
       * Wishlist button class 'is-active' determines whether or not to add or remove
       * If 'is-active', remove the item, otherwise add it
       */
      var updateWishlist = function (self) {
        var productHandle = $(self).attr("data-product-handle");
        var isRemove = $(self).hasClass("is-active");
        var wishlist_value = localStorage.getItem("user_wishlist_count");
        /* Remove */
        if (isRemove) {
          var removeIndex = wishlist.indexOf(productHandle);
          wishlist.splice(removeIndex, 1);
          var wishlist_count = localStorage.getItem("user_wishlist_count");
          if (wishlist_count != null) {
            var minus_val = -1;
            var wish_ct = Math.max(parseInt(wishlist_count) + minus_val, 0);
            localStorage.setItem("user_wishlist_count", wish_ct);
          }
          localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
          var icon_length = $(self).find("span").length;

          if (icon_length != 0 && attr != "product") {
            $wishlistButton.html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
          }
          var wishlist_count_value = localStorage.getItem("user_wishlist_count");
          $wishlitcounter.html(wishlist_count_value);
        } else {
          /* Add */
          wishlist.push(productHandle);
          var wishlist_count = localStorage.getItem("user_wishlist_count");
          if (wishlist_count == null) {
            var plus_val = 1;
            var wish_ct = plus_val;
          } else {
            var plus_val = 1;
            var wish_ct = Math.max(parseInt(wishlist_count) + plus_val, 0);
          }
          localStorage.setItem("user_wishlist_count", wish_ct);
          localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
          var icon_length = $(self).find("span").length;

          ///alert(icon_length);
          if (icon_length != 0 && attr != "product") {
            $wishlistButton.html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
          }
          var wishlist_count_value = localStorage.getItem("user_wishlist_count");
          $wishlitcounter.html(wishlist_count_value);
        }
      };

      /*
       * Loop through product titles and remove any that aren't a part of the wishlist
       * Decrement numProductTiles on removal
       */
      var activateItemsInWishlist = function () {
        $wishlistButton.each(function () {
          var productHandle = $(this).attr("data-product-handle");
          if (wishlist.indexOf(productHandle) > -1) {
            $(this).addClass("is-active");
            var icon_length = $(this).find("span").length;
            if ($(this).hasClass("is-active")) {
              if (icon_length != 0 && attr != "product") {
                $(this).html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
              }
            } else {
              if (icon_length != 0 && attr != "product") {
                $(this).html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
              }
            }
          }
        });
      };
      var displayOnlyWishlistItems = function () {
        $wishlistTile.each(function () {
          var productHandle = $(this).attr("data-product-handle");
          if (wishlist.indexOf(productHandle) === -1) {
            $(this).remove();
            numProductTiles--;
          }
        });
      };

      /*
       * Check if on the wishlist page and hide any items that aren't a part of the wishlist
       * If no wishlist items exist, show the empty wishlist notice
       */
      var loadWishlist = function () {
        if (window.location.href.indexOf("pages/wishlist") > -1) {
          displayOnlyWishlistItems();
          $(".wishlist-loader").fadeOut(2000, function () {
            $(".wishlist-grid").addClass("is_visible");
            $(".wishlist-hero").addClass("is_visible");
            if (numProductTiles == 0) {
              $(".wishlist-grid-empty-list").addClass("is_visible");
              $(".wishlist-grid").hide();
            } else {
              $(".wishlist-grid-empty-list").hide();
            }
          });
        }
      };

      var bindUIActions = function () {
        $wishlistButton.click(function (e) {
          e.preventDefault();
          updateWishlist(this);
          animateWishlist(this);
        });
      };

      Wishlist.init = function () {
        bindUIActions();
        activateItemsInWishlist();
        loadWishlist();
      };

      // Remove All Items..
      $("#remove-done").click(function () {
        var raw = localStorage.getItem("user_wishlist");
        var length = raw.length;
        var i;
        var productHandle = $(self).attr("data-product-handle");
        var isRemove = $(self).hasClass("is-active");

        /* Remove */
        for (i = length - 1; i >= 0; i--) {
          var removeIndex = wishlist.indexOf(productHandle);
          wishlist.splice(removeIndex, 1);
          var wishlist_count = localStorage.getItem("user_wishlist_count");
          if (wishlist_count != null) {
            var wish_ct = Math.max(parseInt(0), 0);
            localStorage.setItem("user_wishlist_count", wish_ct);
          }
          localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
        }
      });

      // wishlist ajax-spin-cart js
      $(".action-wishlist").on("click", function () {
        $(this).addClass("loading-wishlist adding-wishlist");
        setTimeout(function () {
          $(".action-wishlist").removeClass("loading-wishlist");
        }, 1000);
        setTimeout(function () {
          $(".adding-wishlist").removeClass("adding-wishlist");
        }, 2000);
      });
      (function () {
        Wishlist.init();
      })();

      $("input.cust-checkbox[disabled]").parents("li").hide();

      $(".filters-group").each(function (idx) {
        var hide = false;

        if ($(this).find('li input[name="filter.p.product_type"]:checked').length == 0) {
          $(this)
            .find("li")
            .each(function (idx) {
              let $checkbox = $(this).find("input.cust-checkbox");
              if ($checkbox.prop("disabled")) {
                hide = true;
              }
            });
        }

        if (hide) {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter");
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets-mobile", ".active-facets-desktop"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-facets__open", ".mobile-facets__count", ".sorting"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML = source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  async onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    await FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

var PriceRange = /*#__PURE__*/ (function (_HTMLElement) {
  _inherits(PriceRange, _HTMLElement);

  var _super = _createSuper(PriceRange);

  function PriceRange() {
    _classCallCheck(this, PriceRange);

    return _super.apply(this, arguments);
  }

  _createClass(PriceRange, [
    {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;

        this.rangeLowerBound = this.querySelector(".price-range-group input:first-child");
        this.rangeHigherBound = this.querySelector(".price-range-group input:last-child");
        this.textInputLowerBound = this.querySelector(".price-range-input:first-child input");
        this.textInputHigherBound = this.querySelector(".price-range-input:last-child input"); // Select whole text on focus for text field to improve user experience

        this.textInputLowerBound.addEventListener("focus", function () {
          return _this.textInputLowerBound.select();
        });
        this.textInputHigherBound.addEventListener("focus", function () {
          return _this.textInputHigherBound.select();
        }); // Keep in sync the range with the text input fields

        this.textInputLowerBound.addEventListener("change", function (event) {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          _this.rangeLowerBound.value = event.target.value;

          _this.rangeLowerBound.parentElement.style.setProperty("--range-min", "".concat((parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max)) * 100, "%"));
        });
        this.textInputHigherBound.addEventListener("change", function (event) {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          _this.rangeHigherBound.value = event.target.value;

          _this.rangeHigherBound.parentElement.style.setProperty("--range-max", "".concat((parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max)) * 100, "%"));
        });
        this.rangeLowerBound.addEventListener("change", function (event) {
          _this.textInputLowerBound.value = event.target.value;

          _this.textInputLowerBound.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        });
        this.rangeHigherBound.addEventListener("change", function (event) {
          _this.textInputHigherBound.value = event.target.value;

          _this.textInputHigherBound.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        }); // We also have to bound the two range sliders

        this.rangeLowerBound.addEventListener("input", function (event) {
          _this.dispatchEvent(
            new CustomEvent("collection:abort-loading", {
              bubbles: true,
            })
          );

          event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

          event.target.parentElement.style.setProperty("--range-min", "".concat((parseInt(event.target.value) / parseInt(event.target.max)) * 100, "%"));
          _this.textInputLowerBound.value = event.target.value;
        });
        this.rangeHigherBound.addEventListener("input", function (event) {
          _this.dispatchEvent(
            new CustomEvent("collection:abort-loading", {
              bubbles: true,
            })
          );

          event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

          event.target.parentElement.style.setProperty("--range-max", "".concat((parseInt(event.target.value) / parseInt(event.target.max)) * 100, "%"));
          _this.textInputHigherBound.value = event.target.value;
        });
      },
    },
  ]);

  return PriceRange;
})(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));
window.customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

(function ($) {
  translateItems();
})(jQuery);
